import panguSpin from './panguSpin.vue'
export default panguSpin
